import { MisconfigurationsAppNirvanaDataProvider } from '../dataProvider/MisconfigurationsAppNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MisconfigurationsAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MisconfigurationsAppNirvanaDataProvider);
  }
}
